import { render, staticRenderFns } from "./subject-add-or-update.vue?vue&type=template&id=d968b80e&scoped=true"
import script from "./subject-add-or-update.vue?vue&type=script&lang=js"
export * from "./subject-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./subject-add-or-update.vue?vue&type=style&index=0&id=d968b80e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d968b80e",
  null
  
)

export default component.exports